import React from 'react';
import { Switch } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { furnitureModStyles } from './FurnitureMod.styles';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { useSelector } from 'react-redux';

const FurnitureIncludeComponent = React.memo(function FurnitureIncludeComponent(params: any) {
  const { classes } = furnitureModStyles({ isExpanded: false });
  const isModEdit = useSelector(selectIsEditMod);
  return (
    <>
      <Switch checked={params?.row?.include} className={isModEdit ? classes.switchPrimary : classes.switchLightBlue} />{' '}
      {params?.row?.include ? 'Yes' : 'No'}
    </>
  );
});

export const FurnitureInclude = (params: GridCellParams) => {
  return <FurnitureIncludeComponent {...params} />;
};
